var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-crud-page',{attrs:{"master":"notification/contact","title":"Notification Contact","access":"master_notification_contact","pk":"ntcnId","columns":_vm.columns,"fields":_vm.fields,"filters":_vm.filters,"embedded":_vm.embedded,"page-size-selectable":"","forbidden-text":"This module is internal only."}})
}
var staticRenderFns = []

export { render, staticRenderFns }